module.exports = __webpack_public_path__ + "static/media/arrow-alt-left.3d71b595.svg";